import * as React from 'react';
import Grid, { GridColumn } from '@telia-front/grid';
import OfferCounterItem from '../offer-counter-item/offer-counter-item';
class OfferCounter extends React.Component {
    constructor() {
        super(...arguments);
        this.getEdgeClass = (index) => {
            const { itemsPerRowLg } = this.props;
            if (index % itemsPerRowLg === 0) {
                return 'offer-counter__item--edge-start';
            }
            else if ((index + 1) % itemsPerRowLg === 0) {
                return 'offer-counter__item--edge-end';
            }
        };
    }
    getItems() {
        const { itemsPerRowLg, itemsPerRowMd, itemsPerRowSm, itemsPerRowXs } = this.props;
        const colWidthLg = 12 / itemsPerRowLg;
        const colWidthMd = 12 / itemsPerRowMd;
        const colWidthSm = 12 / itemsPerRowSm;
        const colWidthXs = 12 / itemsPerRowXs;
        // TODO: "as TGridColumnWidth" hack can be deleted after: https://github.com/microsoft/TypeScript/pull/41891
        const itemWidth = [
            `lg-${colWidthLg}`,
            `md-${colWidthMd}`,
            `sm-${colWidthSm}`,
            `xs-${colWidthXs}`,
        ];
        let extraKey;
        const childArray = React.Children.toArray(this.props.children)
            .filter((child) => {
            return React.isValidElement(child) && child.type === OfferCounterItem;
        })
            .map((child, i) => {
            const cloneProps = {
                className: this.getEdgeClass(i),
                key: i,
                width: itemWidth,
            };
            extraKey = i + 1;
            return React.cloneElement(child, cloneProps);
        });
        const itemsOnLastRowLg = childArray.length % itemsPerRowLg;
        const itemsOnLastRowMd = childArray.length % itemsPerRowMd;
        const itemsOnLastRowSm = childArray.length % itemsPerRowSm;
        const itemsOnLastRowXs = childArray.length % itemsPerRowXs;
        if (itemsOnLastRowLg !== 0 || itemsOnLastRowMd !== 0 || itemsOnLastRowSm !== 0 || itemsOnLastRowXs !== 0) {
            const itemsToFillRowLg = itemsPerRowLg - itemsOnLastRowLg;
            const itemsToFillRowMd = itemsPerRowMd - itemsOnLastRowMd;
            const itemsToFillRowSm = itemsPerRowSm - itemsOnLastRowSm;
            const itemsToFillRowXs = itemsPerRowXs - itemsOnLastRowXs;
            const extraItemClasses = ['offer-counter__item--edge-end'];
            // TODO: "as TGridColumnWidth" hack can be deleted after: https://github.com/microsoft/TypeScript/pull/41891
            const extraItemWidth = [
                `lg-${itemsToFillRowLg * colWidthLg}`,
                `md-${itemsToFillRowMd * colWidthMd}`,
                `sm-${itemsToFillRowSm * colWidthSm}`,
                `xs-${itemsToFillRowXs * colWidthXs}`,
            ];
            if (itemsToFillRowLg === itemsPerRowLg) {
                extraItemClasses.push('hidden-lg hidden-xl');
            }
            if (itemsToFillRowMd === itemsPerRowMd) {
                extraItemClasses.push('hidden-md');
            }
            if (itemsToFillRowSm === itemsPerRowSm) {
                extraItemClasses.push('hidden-sm');
            }
            if (itemsToFillRowXs === itemsPerRowXs) {
                extraItemClasses.push('hidden-xs');
            }
            childArray.push(React.createElement(OfferCounterItem, { key: extraKey, className: extraItemClasses.join(' '), width: extraItemWidth }));
        }
        return childArray;
    }
    BEM() {
        const classArray = ['offer-counter'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        return (React.createElement(Grid, { align: ['center-xs'], className: this.BEM() },
            React.createElement(GridColumn, { width: ['lg-10', 'md-12'] },
                React.createElement(Grid, { verticalGutter: "none" }, this.getItems()))));
    }
}
OfferCounter.defaultProps = {
    itemsPerRowLg: 6,
    itemsPerRowMd: 4,
    itemsPerRowSm: 3,
    itemsPerRowXs: 2,
};
export default OfferCounter;
